import { z } from "zod";

export const createTemplate = z.object({
  name: z.string(),
  description: z.string(),
  definition: z.record(z.string(), z.any()),
});

export const updateTemplate = z.object({
  id: z.number(),
  name: z.string().optional(),
  description: z.string().optional(),
});

export const createVersion = z.object({
  templateId: z.number(),
  definition: z.record(z.string(), z.any()),
});

export const updateVersion = z.object({
  id: z.number(),
  definition: z.record(z.string(), z.any()),
});
